import { ExibirPaginaComando } from './exibirPaginaComando';
import { EnviarComando } from './enviarComando';

(new ExibirPaginaComando()).executar();
(new EnviarComando()).executar();
